import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectSizeB, selectSizeC, selectShowInvalids } from '@store/order/selectors';
import { setSizeB, setSizeC } from '@store/order/slice';
import catDimensionsFull from '@assets/images/order-cat-dimensions-full.svg';
import NumberField from '@components/text-field/NumberField';
import { invalidFormValue } from '@components/utils';



const DimensionsSection = (): JSX.Element => {

	const sizeB = useSelector(selectSizeB);
	const sizeC = useSelector(selectSizeC);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateSizeB = (value: number | null) => dispatch(setSizeB(value));
	const updateSizeC = (value: number | null) => dispatch(setSizeC(value));

	return (
		<div className='dimensions-section'>
			
			<div className='dimensions-image'>
				<div className='dimensions-labels'>
					<p><span>A</span>Obvod krku</p>
					<p><span>B</span>Výška kočky v kohoutku</p>
				</div>
				<img src={catDimensionsFull} alt='animal-dimensions-image' />
			</div>
			
			<label className='dimensions-label'>
				Rozměry zvířete <span>*</span>
			</label>
		
			<div className='dimensions-inputs'>
				
				<NumberField
					label='A'
					placeholder='cm'
					valueUnits='cm'
					rounded={true}
					value={sizeB}
					allowDecimal={false}
					maxNumber={1000}
					onChange={updateSizeB}
					errorMessage={showInvalids && invalidFormValue(sizeB) ? 'Povinné pole' : undefined} />
				
				<NumberField
					label='B'
					placeholder='cm'
					valueUnits='cm'
					rounded={true}
					value={sizeC}
					allowDecimal={false}
					maxNumber={1000}
					onChange={updateSizeC}
					errorMessage={showInvalids && invalidFormValue(sizeC) ? 'Povinné pole' : undefined} />
			</div>

			<p>* Prosím, pečlivě zkontrolujte, že jste měřili Vašeho kamaráda správně, jde o každý centimetr! Zvíře musí stát rovně, nesmí být pokrčené. Aby límec seděl dobře na krku a zbytečně jej neškrtil, pod metr, kterým zvíře měříte, vsuňte dva prsty.</p>
		
			<p className='dimensions-link'>{'Víte jak správně měřit? '}
				<Link to={'https://www.youtube.com/watch?v=85DMGTG_z7M'} className='disable-selection' target='_blank'>
					Koukněte na naše video
				</Link>.
			</p>

		</div>
	);
};

export default memo(DimensionsSection);